import { CloseIcon } from '@braskai/icons';
import { IconButton, Link, Modal, ModalContent, ModalWrapper } from '@braskai/ui-kit';
import { useNavigate } from 'react-router-dom';

import { Box, Stack, Typography } from '@mui/material';

import { FeaturedError } from '@/shared/assets/icons/FeaturedError';
import { FeaturedIcon } from '@/shared/assets/icons/FeaturedIcon';
import { PATHS } from '@/shared/constants/routes/paths';
import { useCustomerPortal } from '@/shared/hooks/useCustomerPortal';

import { useAfterPurchaseModalStore } from './hooks/useAfterPurchaseModalStore';

const AfterPurchaseModalComponent = () => {
  const { buttonText: customButtonText, close, description, invoiceUrl, isError, showInvoiceLink } = useAfterPurchaseModalStore();
  const { isCustomerPortalLoading, openCustomerPortal } = useCustomerPortal();
  const navigate = useNavigate();

  const handleViewInvoice = async () => {
    if (isError && invoiceUrl) {
      window.open(invoiceUrl, '_blank');
      return;
    }

    if (isError) {
      close();
      navigate(`/${PATHS.account}`, { replace: true });
      await openCustomerPortal({ navigateTo: 'portal' });
      return;
    }

    await openCustomerPortal({ navigateTo: 'portal' });
  };

  const handleClose = () => {
    close();
    if (isError) {
      navigate(`/${PATHS.pricing}`, { replace: true });
    } else {
      navigate(`/${PATHS.account}`, { replace: true });
    }
  };

  const buttonText = customButtonText || 'View invoice';

  return (
    <Modal size="xs" open onClose={handleClose}>
      <ModalContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <IconButton disableFixSizeIcon onClick={handleClose}>
            <CloseIcon height={24} width={24} />
          </IconButton>
        </Box>
        <Stack alignItems="center" gap={20} paddingBottom={48} textAlign="center">
          {isError ? <FeaturedError height={56} width={56} /> : <FeaturedIcon height={56} width={56} />}
          <Stack alignItems="center" gap={8}>
            <Typography color="grey.500" sx={{ maxWidth: 250 }} textAlign="center" variant="body-2">
              {description}
            </Typography>

            {(showInvoiceLink || isError ) && (
              <Link
                sx={{
                  cursor: 'pointer',
                }}
                disabled={isCustomerPortalLoading}
                size="md"
                onClick={handleViewInvoice}
              >
                {buttonText}
              </Link>
            )}
          </Stack>
        </Stack>
      </ModalContent>
    </Modal>
  );
};

export const AfterPurchaseModal = () => (
  <ModalWrapper hook={useAfterPurchaseModalStore}>
    <AfterPurchaseModalComponent />
  </ModalWrapper>
);
